import { createFileRoute } from '@tanstack/react-router';

import { SeasonEditPage } from '@/components/admin/sport/season-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetSeasonFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/seasons_/$id')({
    component: SeasonEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'עונה חדשה' : 'עריכת עונה',
            `/admin/sport/seasons/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetSeasonFn({ data: { id: params.id } });
    },
});

function SeasonEditRoute() {
    const data = Route.useLoaderData();
    const key = useAdminEditPageKey(
        data?.season ? `${data.season.id}:${String(data.season.updatedAt)}` : undefined,
    );
    return <SeasonEditPage key={key} data={data} />;
}
